import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

// CEO who is ALSO a developer — the super-admin gate for the cross-user ARON audit
// (full transcript access). Mirrors the backend IsCEOAndDeveloper permission.
export function CEODevGuard({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user?.is_ceo || !user?.is_developer) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
